import { ANTRAGS_FORMULAREN } from 'src/lib/constants/constant';

export const KMU_VARIANTE = {
	erste: 'erste',
	zweite: 'zweite',
};

const ersteVariante = [
	ANTRAGS_FORMULAREN.EmobInvest,
	ANTRAGS_FORMULAREN.EmobFundE,
	ANTRAGS_FORMULAREN.EmobLis,
	ANTRAGS_FORMULAREN.LogistikUndMobilitaet,
];

const zweiteVariante = [
	ANTRAGS_FORMULAREN.Loewe,
	ANTRAGS_FORMULAREN.Elektrobusse,
	ANTRAGS_FORMULAREN.Mobilitaetsplaene,
	ANTRAGS_FORMULAREN.StartUpStipendium,
	ANTRAGS_FORMULAREN.StartUpProjekte,
	ANTRAGS_FORMULAREN.Kreativwirtschaft,
	ANTRAGS_FORMULAREN.Messefoerderung,
	ANTRAGS_FORMULAREN.Entwicklungszusammenarbeit,
];

export const getKmuVariante = (antragsformular: string) => {
	if (ersteVariante.includes(antragsformular)) {
		return KMU_VARIANTE.erste;
	} else if (zweiteVariante.includes(antragsformular)) {
		return KMU_VARIANTE.zweite;
	}
};
